import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return toObservable(authService.authInitialized).pipe(
    filter(initialized => initialized),
    take(1),
    map(() => {
      const user = authService.authenticatedUser();
      if (user && user.admin) {
        return true;
      }
      router.navigate(['/app/discover']).finally();
      return false;
    })
  );
};
